export default {
  create: 'Create Product',
  placeholder: 'please enter to search',
  productName: 'Name',
  productStatus: 'Status',
  productDescription: 'Description',
  productType: 'Type',
  productRemark: 'Remark',
  productStatusEnum: {
    off: 'off',
    on: 'on',
  },
};
